import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="h-10 w-10 animate-spin text-[#C8102E]" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/staff/login" replace />;
  return children;
}
